export const templateSession = (dataSession) => {
	const mailTemplateSession =
		`<div style="text-align:justify;">
		<p><strong>#usuario#,</strong></p>

		<br>

		<p>La sesión <strong><a href="` +
		window.location.href +
		`" target="_blank" style="color: rgb(0,0,0);">` +
		dataSession.numero_sesion +
		`</a></strong> del órgano colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> ha sido publicada, para consultarla haga click.</p>
		<br>
		<br>
		<b>Atentamente</b>
		<br>
		<br>
		<b><strong>Marcos Manuel Herrería Alamina</strong></b>
		<br>
		<b><strong>Secretario General y Jurídico del Instituto del Fondo Nacional de la Vivienda para los Trabajadores.</strong></b>
		</div>
		`;

	const mailTemplateSessionIncoformidades =
		`<div style="text-align:justify;"><p><strong>#usuario#,</strong></p>

		<br>

		<p>La sesión <strong><a href="` +
		window.location.href +
		`" target="_blank" style="color: rgb(0,0,0);">` +
		dataSession.numero_sesion +
		`</a></strong> del órgano colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> ha sido publicada, para consultarla haga click.</p>

		<br>

		<br>

		<p>Atentamente</p>

		<br>

		<p><strong>Lic. Patricia González Sánchez</strong></p>

		<p><strong>Secretaria Técnica de la Comisión de Inconformidades</strong></p>
		</div>
		`;

	return dataSession.nameOrgan === 'Comisión de Inconformidades'
		? mailTemplateSessionIncoformidades
		: mailTemplateSession;
};
